import React from "react"
import TMPButton from "../../components/TMPButton"
import TextField from "../../components/TextField"
import ProgressView from "../../components/ProgressView"
import useBusinesses from "../../hooks/useBusinesses"

const SendSMSMessage = () => {

    const {sendAnyMessageToBusiness, message, setMessage, isLoading, phone, setPhone} = useBusinesses()


    return (
        <React.Fragment>

            <TextField
                className="form-control"
                onChange={e => setPhone(e.target.value)}
                value={phone}
                label={"Phone number"}/>

            <TextField
                textarea={true}
                className="form-control"
                onChange={e => setMessage(e.target.value)}
                value={message}
                label={"Write message"}/>


            <div>
                {isLoading ? <ProgressView/> :
                    <TMPButton
                        onClick={e => sendAnyMessageToBusiness()}>Send</TMPButton>}
            </div>


        </React.Fragment>
    )
}

export default SendSMSMessage
